/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Measure_Reliability_First_LaneInputs */

const en_measure_reliability_first_lane = /** @type {(inputs: Measure_Reliability_First_LaneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Succeeded on first lane`)
};

const zh_hans1_measure_reliability_first_lane = /** @type {(inputs: Measure_Reliability_First_LaneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首选线路成功`)
};

const pt_br2_measure_reliability_first_lane = /** @type {(inputs: Measure_Reliability_First_LaneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sucesso na primeira rota`)
};

const es_measure_reliability_first_lane = /** @type {(inputs: Measure_Reliability_First_LaneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Éxito en la primera fuente`)
};

const fr_measure_reliability_first_lane = /** @type {(inputs: Measure_Reliability_First_LaneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réussi sur la première source`)
};

const de_measure_reliability_first_lane = /** @type {(inputs: Measure_Reliability_First_LaneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei der ersten Quelle erfolgreich`)
};

const ru_measure_reliability_first_lane = /** @type {(inputs: Measure_Reliability_First_LaneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Успешно с первого источника`)
};

const it_measure_reliability_first_lane = /** @type {(inputs: Measure_Reliability_First_LaneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riuscite alla prima fonte`)
};

/**
* | output |
* | --- |
* | "Succeeded on first lane" |
*
* @param {Measure_Reliability_First_LaneInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_reliability_first_lane = /** @type {((inputs?: Measure_Reliability_First_LaneInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Reliability_First_LaneInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_reliability_first_lane(inputs)
	if (locale === "pt-BR") return pt_br2_measure_reliability_first_lane(inputs)
	if (locale === "es") return es_measure_reliability_first_lane(inputs)
	if (locale === "fr") return fr_measure_reliability_first_lane(inputs)
	if (locale === "de") return de_measure_reliability_first_lane(inputs)
	if (locale === "ru") return ru_measure_reliability_first_lane(inputs)
	if (locale === "it") return it_measure_reliability_first_lane(inputs)
	return en_measure_reliability_first_lane(inputs)
});